"use client";
import { Button, cn } from "@heroui/react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { motion } from "framer-motion";
import * as UA from "ua-parser-js";
import Link from "next/link";

export default function AppDownloadNavbar() {
  const t = useTranslations();
  const [isOpen, setOpen] = useState<boolean>(true);
  const [osName, setOSName] = useState<string>();

  useEffect(() => {
    if (document)
      if (!isOpen) {
        document.documentElement.style.setProperty("--misc-dl-height", "0rem");
      } else document.documentElement.style.removeProperty("--misc-dl-height");
  }, [isOpen]);

  useEffect(() => {
    if (typeof window.Android !== "undefined") {
      setOSName("android-app");
      return;
    }
    const parser = new UA.UAParser();
    setOSName(parser.getOS().name?.toLowerCase());
    /(ios|mac|macintosh|iphone)/i.test(parser.getOS().name?.toLowerCase() || "") &&
      document.documentElement.style.setProperty("--misc-dl-height", "0rem");
  }, []);
  return /(ios|mac|macintosh|iphone|android\-app)/i.test(osName || "") ? (
    <></>
  ) : (
    <>
      <div className={cn("sticky top-0 h-20 flex-none transition-height sm:hidden", !isOpen && "h-0")} />
      <div
        className={cn("fixed left-0 top-0 h-20 w-full transition-transform sm:hidden", !isOpen && "-translate-y-full")}
      >
        <div className={cn("flex h-full w-full items-center justify-between gap-4 bg-[#021517] px-4")}>
          <Image src={"/favicon.webp"} width={40} height={40} alt="Favicon" />
          <div className="w-1/2 text-tiny font-bold">{t("navbar-download-text")}</div>
          <Button as={Link} href={"/api/download"} download color="primary" className="font-bold">
            {t("download")}
          </Button>
          <IoCloseOutline
            className="transition-transform active:scale-95"
            role="button"
            onClick={() => setOpen(false)}
            size={24}
          />
        </div>
      </div>
    </>
  );
}
